import InjuryReportScreen from "@/components/screens/InjuryReportScreen";

export default function InjuryReportPage() {
  return <InjuryReportScreen />;
}
